import { Navigate, Outlet } from 'react-router';

import {
    LearningContentPage,
    LearningObjectivesPage,
    NoMatch,
    ProgrammePage,
    ProgrammesConnectionsPage,
    ProgrammesPage,
} from '@features';

export const routes = [
    {
        path: '/',
        element: <Navigate to="/learning-objectives" />,
    },
    {
        path: 'learning-objectives',
        element: <LearningObjectivesPage />,
    },
    {
        path: 'learning-content',
        children: [
            {
                path: ':learningObjectiveId',
                element: <LearningContentPage />,
            },
        ],
    },
    {
        path: 'programmes',
        element: <Outlet />,
        children: [
            {
                index: true,
                element: <ProgrammesPage />,
            },
            {
                path: 'connections',
                element: <ProgrammesConnectionsPage />,
            },
            {
                path: ':programmeId',
                element: <ProgrammePage />,
            },
        ],
    },
    {
        path: '*',
        element: <NoMatch />,
    },
];

export const routesInfo: {
    [path: string]: {
        url?: string;
        label: string;
        menuItems?: {
            url: string;
            label: string;
        }[];
        altPath?: string;
    };
} = {
    '/learning-objectives': {
        url: '/learning-objectives',
        label: 'Learning Objectives',
        altPath: '/learning-content',
    },
    '/programmes': {
        url: '/programmes',
        label: 'Programmes',
    },
};
